/**
 * The funds' Bitcoin-backed loan terms, as the Borrow calculator uses them. Edit here when the
 * terms change; a fund whose terms differ gets an entry in LOAN_TERMS_BY_PROJECT (only the fields
 * that differ). Indicative only: final terms come from the fund managers.
 */
export interface LoanTerms {
  /** Simple interest per year, as a fraction (0.105 = 10.5%), paid with the loan at maturity. */
  rate: number
  ltvOptions: readonly number[]
  defaultLtv: number
  termMonths: readonly number[]
  defaultTermMonths: number
  /** USD. */
  minLoan: number
  maxLoan: number
  /** Loan-to-value levels at which the lender acts. */
  firstMarginCall: number
  secondMarginCall: number
  liquidation: number
  /** Shown as written. */
  custody: string
  custodian: string
  loanCurrencies: string
  /** Where "Request loan offer" sends its email. */
  offerEmail: string
}

export const DEFAULT_LOAN_TERMS: LoanTerms = {
  rate: 0.105,
  ltvOptions: [0.5, 0.55, 0.6],
  defaultLtv: 0.5,
  termMonths: [3, 6, 9, 12],
  defaultTermMonths: 6,
  minLoan: 150_000,
  maxLoan: 2_000_000,
  firstMarginCall: 0.78,
  secondMarginCall: 0.8,
  liquidation: 0.83,
  custody: '3-of-4 multi-sig',
  custodian: 'Debifi',
  loanCurrencies: 'USD, USD stablecoins',
  offerEmail: 'krstic@sicos.io',
}

/** Keyed by project name (`aquarius`, `goldstream`). */
export const LOAN_TERMS_BY_PROJECT: Record<string, Partial<LoanTerms>> = {}

export const loanTermsFor = (projectName: string | undefined): LoanTerms => ({
  ...DEFAULT_LOAN_TERMS,
  ...(projectName ? LOAN_TERMS_BY_PROJECT[projectName] : undefined),
})
